import './book-event-form.scss';
import BookingCheckout, {
  CreditTypesEnum,
} from '../../../shared/BookingCheckout';
import EventFormInfo from './EventFormInfo';
import {
  BookedStatusEnum,
  Event,
  EventStatusEnum,
} from '../../../../store/events/eventTypes';
import { useTranslation } from 'react-i18next';
import BookEventFormGuests from './BookEventFormGuests';
import BookEventFormActions from './BookEventFormActions';
import ShowPolicyButton from './ShowPolicyButton/ShowPolicyButton';
import { getTimeStringFromTimestamp } from '../../../../utility/functions/getTimeStringFromTimestamp';

type PropsTypes = {
  event: Event;
  showPolicy: boolean;
  onSwitchShowPolicy: () => void;
  onClickJoinWaitingList: () => Promise<void>;
  onBookEvent: () => Promise<void>;
};

const BookEventForm = ({
  event,
  onBookEvent,
  onClickJoinWaitingList,
  onSwitchShowPolicy,
  showPolicy,
}: PropsTypes) => {
  const { t } = useTranslation();

  return (
    <div className="book-event-form">
      <div className="book-event-form-content">
        <EventFormInfo
          title={t('EVENT_DETAILS_TITLE')}
          price={event.price}
          date={new Date(event.fromDate).toDateString()}
          time={getTimeStringFromTimestamp(+event.fromDate)}
          placesLeft={event.capacity - event.participants.length}
          capacity={event.capacity}
          locationName={event.resource?.building?.location?.name}
          buildingName={event.resource?.building?.name}
          floorNumber={event.resource?.floor?.number}
        />
        <BookEventFormGuests participants={event.participants} />
        <BookingCheckout
          creditTypes={CreditTypesEnum.USER}
          price={+event.price}
          disabledCreditUser={!event.creditAllowed}
          isWaitingListMode={
            event.bookedStatus === BookedStatusEnum.IN_WAIT_LIST
          }
          isPurchasable={event.status === EventStatusEnum.AVAILABLE}
        />
        <BookEventFormActions
          waitingListMode={event.status === EventStatusEnum.FULL}
          onBookEvent={onBookEvent}
          onJoinWaitingList={onClickJoinWaitingList}
        />
        <ShowPolicyButton
          showPolicy={showPolicy}
          onSwitchShowPolicy={onSwitchShowPolicy}
        />
      </div>
    </div>
  );
};

export default BookEventForm;
